exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".scroll-container[data-v-415f9896]{position:relative;width:100%;height:100%;background-color:#304156}.scroll-container .scroll-wrapper[data-v-415f9896]{position:absolute;width:100%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-415f9896","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/widgets/ScrollBar.vue
// module id = 1164
// module chunks = 0